"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var elog = require("../../elog");
var removeMD = require("remove-markdown");
var react_helmet_1 = require("react-helmet");
var constants_1 = require("../../constants");
var COMPONENT_NAME = 'CmsPageTitle';
var CmsPageTitle = /** @class */ (function (_super) {
    tslib_1.__extends(CmsPageTitle, _super);
    function CmsPageTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CmsPageTitle, "defaultProps", {
        get: function () {
            return {
                twitterHandle: '@reverb',
                defaultOgImageUrl: constants_1.CORE_DEFAULT_OG_IMAGE_URL,
                siteName: 'reverb.com',
                fbAppId: '405002109547804',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CmsPageTitle.prototype, "translationKey", {
        get: function () {
            return this.props.isLP ? 'lpHead' : 'head';
        },
        enumerable: true,
        configurable: true
    });
    CmsPageTitle.prototype.buildTitle = function (title) {
        var postfix = I18n.t("cms." + this.translationKey + ".postfix");
        var fullTitle = I18n.t("cms." + this.translationKey + ".fullTitle", { title: title, postfix: postfix });
        return removeMD(fullTitle);
    };
    CmsPageTitle.prototype.renderPageTitle = function () {
        var _a = this.props, title = _a.title, page = _a.page;
        if (!title) {
            return this.buildTitle(I18n.t("cms." + this.translationKey + ".defaultTitle"));
        }
        if (page && page > 1) {
            var titleWithPage = I18n.t("cms." + this.translationKey + ".titleWithPage", { page: page, title: title });
            return this.buildTitle(titleWithPage);
        }
        return this.buildTitle(title);
    };
    CmsPageTitle.prototype.renderOGTitle = function () {
        return this.renderPageTitle();
    };
    CmsPageTitle.prototype.renderOGImage = function () {
        var _a = this.props, image = _a.image, metaImage = _a.metaImage;
        return metaImage || image || this.props.defaultOgImageUrl;
    };
    CmsPageTitle.prototype.renderOGDescription = function () {
        var ogDescription = removeMD(this.props.ogDescription);
        return ogDescription || this.renderDescription();
    };
    CmsPageTitle.prototype.renderDescription = function () {
        var description = removeMD(this.props.description);
        return description || I18n.t("cms." + this.translationKey + ".defaultDescription");
    };
    CmsPageTitle.prototype.renderNoIndex = function () {
        if (!this.props.noIndex) {
            return null;
        }
        return (React.createElement("meta", { name: "robots", content: "noindex" }));
    };
    CmsPageTitle.prototype.renderCanonicalLink = function () {
        if (!this.props.canonicalHref)
            return null;
        return (React.createElement("link", { rel: "canonical", href: this.props.canonicalHref }));
    };
    CmsPageTitle.prototype.render = function () {
        try {
            return (React.createElement(react_helmet_1.default, null,
                !this.props.isLP &&
                    React.createElement("meta", { property: "fb:app_id", content: this.props.fbAppId }),
                React.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
                React.createElement("meta", { name: "twitter:site", content: this.props.twitterHandle }),
                React.createElement("meta", { name: "twitter:title", content: this.renderOGTitle() }),
                React.createElement("meta", { name: "twitter:description", content: this.renderOGDescription() }),
                React.createElement("meta", { name: "twitter:image", content: this.renderOGImage() }),
                React.createElement("meta", { property: "og:title", content: this.renderOGTitle() }),
                React.createElement("meta", { property: "og:description", content: this.renderOGDescription() }),
                React.createElement("meta", { property: "og:image", content: this.renderOGImage() }),
                React.createElement("meta", { property: "og:site_name", content: this.props.siteName }),
                React.createElement("meta", { property: "og:url", content: this.props.canonicalHref }),
                React.createElement("meta", { name: "description", content: this.renderDescription() }),
                React.createElement("title", null, this.renderPageTitle()),
                this.renderNoIndex(),
                this.renderCanonicalLink()));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    return CmsPageTitle;
}(React.Component));
exports.default = CmsPageTitle;
//# sourceMappingURL=cms_page_title.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/cms_page_title.js
// module id = +EYn
// module chunks = 0 2 6 13 20